import React, { Component } from 'react'
import {Route} from 'react-router-dom';

import PagMasInfo from "./PagMasInfo";
import PagAlguien from './PagConozcoAlguien';  
import PagProfesionales from './PagProfesionales';
import PagSobreLaApp from "./PagSobreLaApp";

import NavBar from "./NavExtra";
import "./../styles/extraStyle.css";

export default class RutasPagsExtra extends Component {
    render() {
        return (
            <div className="ContainerInfo">
                <NavBar/>
                <div className="ContenidoPaginaUser">
                    <Route path="/extra/masInfo" component={PagMasInfo}/>
                    <Route path="/extra/conozcoAlguien" component={PagAlguien}/>
                    <Route path="/extra/profesionales" component={PagProfesionales}/>
                    <Route path="/extra/sobreLaApp" component={PagSobreLaApp}/>
                </div>
            </div>
        )
    }
}
